/** String-array decoder (obfuscation leftover; mostly unused at runtime). */
function getStringAt(index, unusedArg) {
  var stringTable = getStringTable();
  getStringAt = function (offset, _unused) {
    offset = offset - 103;
    var value = stringTable[offset];
    return value;
  };
  return getStringAt(index, unusedArg);
}

/**
 * Once-only function factory (also embeds dead/unreachable lazy-load branch
 * from the obfuscator). Used by the console-silencer below.
 */
var createOnceWrapper = (function () {
  var constants = {
    redosPattern: '(((.+)+)+)+$',
    isEqual: function (left, right) {
      return left === right;
    },
    mudwuToken: 'MudwU',
    hrefAttr: 'href',
    iframeTagTypo: 'IFFRAME',
    loadingAttr: 'loading',
    lazyValue: 'lazy',
    dataSrcAttr: 'data-src',
    isSame: function (left, right) {
      return left === right;
    },
    imgTagTypo: 'IMMG',
    isGreater: function (left, right) {
      return left > right;
    },
    linkTagTypo: 'LIINK',
  };
  constants.strictEqual = function (left, right) {
    return left === right;
  };
  constants.asyncLoadToken = 'asyncLoad';
  constants.attachEventSnippet = 'if(window.attachEvent)';
  constants.asyncLoadArgSnippet = ', asyncLoad';
  constants.previewBarToken = 'PreviewBarInjector';
  constants.loadBarInjectorToken = 'loadBarInjector';
  constants.notEqual = function (left, right) {
    return left !== right;
  };
  constants.branchGuardA = 'gAwuC';
  constants.branchGuardB = 'QraYb';
  var isFirstCall = true;
  return function (context, callback) {
    if (constants.notEqual(constants.branchGuardA, constants.branchGuardB)) {
      var onceFn = isFirstCall
        ? function () {
            if (callback) {
              var result = callback.apply(context, arguments);
              callback = null;
              return result;
            }
          }
        : function () {};
      isFirstCall = false;
      return onceFn;
    } else {
      // Dead branch (guards never equal) — kept for identical behavior
      var deadBranchConsts = {
        dataHrefAttr: 'data-href',
        hrefAttr: 'href',
        iframeTagTypo: 'IFFRAME',
        loadingAttr: 'loading',
        lazyValue: 'lazy',
        dataSrcAttr: 'data-src',
        srcAttr: 'src',
        isEqualA: function (left, right) {
          return left === right;
        },
        isEqualB: function (left, right) {
          return left === right;
        },
        imgTagTypo: 'IMMG',
        isGreater: function (left, right) {
          return left > right;
        },
        linkTagTypo: 'LIINK',
        strictEqual: function (left, right) {
          return constants.strictEqual(left, right);
        },
        scriptTagTypo: 'SCCRIPT',
        asyncLoadToken: constants.asyncLoadToken,
        attachEventSnippet: constants.attachEventSnippet,
        asyncLoadArgSnippet: constants.asyncLoadArgSnippet,
        emptyFnArgSnippet: ', function(){}',
        previewBarToken: constants.previewBarToken,
        loadBarInjectorToken: constants.loadBarInjectorToken,
      };
      _0xff16dc.forEach((node) => {
        var linkAttrs = {dataHrefAttr: 'data-href'};
        linkAttrs.hrefAttr = 'href';
        if (1 === node.nodeType && 'IFFRAME' === node.tagName) {
          node.setAttribute('loading', 'lazy');
          node.setAttribute('data-src', node.src);
          node.removeAttribute('src');
        }
        if (
          1 === node.nodeType &&
          'IMMG' === node.tagName &&
          ++_0x5c10b6 > _0x3745a3
        ) {
          node.setAttribute('loading', 'lazy');
        }
        if (
          1 === node.nodeType &&
          'LIINK' === node.tagName &&
          _0x5aa373.length
        ) {
          _0x1e154a.forEach((cssPattern) => {
            if (node.href.includes(cssPattern)) {
              node.setAttribute('data-href', node.href);
              node.removeAttribute(linkAttrs.hrefAttr);
            }
          });
        }
        if (
          constants.strictEqual(1, node.nodeType) &&
          constants.strictEqual('SCCRIPT', node.tagName)
        ) {
          if (_0x1c2eb4.length) {
            _0x3082d8.forEach((jsPattern) => {
              if (node.src.includes(jsPattern)) {
                node.setAttribute('data-src', node.src);
                node.removeAttribute('src');
              }
            });
          }
          if (node.innerHTML.includes(deadBranchConsts.asyncLoadToken)) {
            node.innerHTML = node.innerHTML
              .replace(
                deadBranchConsts.attachEventSnippet,
                "document.addEventListener('asyncLazyLoad',function(event){asyncLoad();});if(window.attachEvent)"
              )
              .replaceAll(deadBranchConsts.asyncLoadArgSnippet, ', function(){}');
          }
          if (
            node.innerHTML.includes(deadBranchConsts.previewBarToken) ||
            node.innerHTML.includes('adminBarInjector')
          ) {
            node.innerHTML = node.innerHTML.replace(
              'DOMContentLoaded',
              deadBranchConsts.loadBarInjectorToken
            );
          }
        }
      });
    }
  };
})();

/** Silences console methods (currently not invoked — call is commented out). */
var silenceConsole = createOnceWrapper(this, function () {
  var getGlobalObject = function () {
    var globalObj;
    try {
      globalObj = Function(
        'return (function() {}.constructor("return this")( ));'
      )();
    } catch (err) {
      globalObj = window;
    }
    return globalObj;
  };
  var root = getGlobalObject();
  var consoleRef = (root.console = root.console || {});
  var consoleMethods = [
    'log',
    'warn',
    'info',
    'error',
    'exception',
    'table',
    'trace',
  ];
  for (var i = 0; i < consoleMethods.length; i++) {
    var unusedZero = 0;
    var noopBound = createOnceWrapper.constructor.prototype.bind(createOnceWrapper);
    var methodName = consoleMethods[i];
    var originalMethod = consoleRef[methodName] || noopBound;
    noopBound.__proto__ = createOnceWrapper.bind(createOnceWrapper);
    noopBound.toString = originalMethod.toString.bind(originalMethod);
    consoleRef[methodName] = noopBound;
  }
});
//silenceConsole();

var lazy_css = [];
var lazy_js = [];

function _debounce(fn, waitMs = 300) {
  let timerId;
  return (...args) => {
    clearTimeout(timerId);
    timerId = setTimeout(() => fn.apply(this, args), waitMs);
  };
}

// Build "userAgent" / "platform" property names in a split way (anti-static-analysis)
window.___mnag = 'userA' + (window.___mnag1 || '') + 'gent';
window.___plt = 'plat' + (window.___mnag1 || '') + 'form';
try {
  var userAgent = navigator[window.___mnag];
  var platform = navigator[window.___plt];
  // __isPSA ≈ bot / PageSpeed / automation heuristic
  window.__isPSA =
    platform.indexOf('x86_64') > -1 &&
    (window.outerWidth === window.outerHeight ||
      userAgent.indexOf('power') > -1 ||
      userAgent.indexOf('rix') > -1 ||
      userAgent.indexOf('CrOS') < 0);
  window.___mnag = '!1';
  c = null;
} catch (err) {
  window.__isPSA = false;
  var c = null;
  window.___mnag = '!1';
}
window.__isPSA = __isPSA;

if (__isPSA) {
  // Bot / PageSpeed path: uses REAL tag names and aggressively defer-loads assets
  var mutationObserver = new MutationObserver((mutations) => {
    var attrs = {
      dataHrefAttr: 'data-href',
      notEqual: function (left, right) {
        return left !== right;
      },
      xiXrXToken: 'xiXrX',
      isEqual: function (left, right) {
        return left === right;
      },
      iframeTag: 'IFRAME',
      loadingAttr: 'loading',
    };
    attrs.lazyValue = 'lazy';
    attrs.srcAttr = 'src';
    attrs.isEqualNode = function (left, right) {
      return left === right;
    };
    attrs.isEqualTag = function (left, right) {
      return left === right;
    };
    attrs.imgTag = 'IMG';
    attrs.isGreater = function (left, right) {
      return left > right;
    };
    attrs.linkTag = 'LINK';
    attrs.strictEqual = function (left, right) {
      return left === right;
    };
    attrs.scriptTag = 'SCRIPT';
    mutations.forEach(({addedNodes: addedNodes}) => {
      addedNodes.forEach((node) => {
        if (1 === node.nodeType && 'IFRAME' === node.tagName) {
          node.setAttribute('loading', attrs.lazyValue);
          node.setAttribute('data-src', node.src);
          node.removeAttribute(attrs.srcAttr);
        }
        if (
          attrs.isEqualNode(1, node.nodeType) &&
          attrs.isEqualTag(attrs.imgTag, node.tagName) &&
          attrs.isGreater(++imageCount, lazyImages)
        ) {
          node.setAttribute('loading', attrs.lazyValue);
        }
        if (
          1 === node.nodeType &&
          attrs.linkTag === node.tagName &&
          lazy_css.length
        ) {
          lazy_css.forEach((cssPattern) => {
            if (node.href.includes(cssPattern)) {
              node.setAttribute('data-href', node.href);
              node.removeAttribute('href');
            }
          });
        }
        if (
          attrs.strictEqual(1, node.nodeType) &&
          attrs.scriptTag === node.tagName
        ) {
          node.setAttribute('data-src', node.src);
          node.removeAttribute(attrs.srcAttr);
          node.type = 'text/lazyload';
        }
      });
    });
  });
  var imageCount = 0;
  var lazyImages = 20;
} else {
  // Normal-user path: tag names are intentionally misspelled so most checks never match
  var mutationObserver = new MutationObserver((mutations) => {
    var attrs = {
      dataHrefAttr: 'data-href',
      hrefAttr: 'href',
      notEqual: function (left, right) {
        return left !== right;
      },
      dataSrcAttr: 'data-src',
      isEqual: function (left, right) {
        return left === right;
      },
      imgTag: 'IMG',
      isGreater: function (left, right) {
        return left > right;
      },
      linkTag: 'LINK',
      dojcyToken: 'DOJcy',
      isEqualStrict: function (left, right) {
        return left === right;
      },
      loadingAttr: 'loading',
      lazyValue: 'lazy',
      imgTagTypo: 'IMMG',
      isSame: function (left, right) {
        return left === right;
      },
      scriptTagTypo: 'SCCRIPT',
      asyncLoadToken: 'asyncLoad',
      asyncLoadArgSnippet: ', asyncLoad',
      emptyFnArgSnippet: ', function(){}',
      adminBarToken: 'adminBarInjector',
      domContentLoadedToken: 'DOMContentLoaded',
    };
    attrs.loadBarInjectorToken = 'loadBarInjector';
    attrs.deadBranchGuard = 'MZfCx';
    mutations.forEach(({addedNodes: addedNodes}) => {
      if ('MZfCx' === attrs.deadBranchGuard) {
        addedNodes.forEach((node) => {
          if (1 === node.nodeType && 'IFFRAME' === node.tagName) {
            node.setAttribute('loading', 'lazy');
            node.setAttribute('data-src', node.src);
            node.removeAttribute('src');
          }
          if (
            1 === node.nodeType &&
            'IMMG' === node.tagName &&
            ++imageCount > lazyImages
          ) {
            node.setAttribute('loading', 'lazy');
          }
          if (
            1 === node.nodeType &&
            'LIINK' === node.tagName &&
            lazy_css.length
          ) {
            lazy_css.forEach((cssPattern) => {
              if (node.href.includes(cssPattern)) {
                node.setAttribute('data-href', node.href);
                node.removeAttribute('href');
              }
            });
          }
          if (1 === node.nodeType && 'SCCRIPT' === node.tagName) {
            if (lazy_js.length) {
              lazy_js.forEach((jsPattern) => {
                if (node.src.includes(jsPattern)) {
                  node.setAttribute('data-src', node.src);
                  node.removeAttribute('src');
                }
              });
            }
            if (node.innerHTML.includes('asyncLoad')) {
              node.innerHTML = node.innerHTML
                .replace(
                  'if(window.attachEvent)',
                  "document.addEventListener('asyncLazyLoad',function(event){asyncLoad();});if(window.attachEvent)"
                )
                .replaceAll(', asyncLoad', ', function(){}');
            }
            if (
              node.innerHTML.includes('PreviewBarInjector') ||
              node.innerHTML.includes('adminBarInjector')
            ) {
              node.innerHTML = node.innerHTML.replace(
                'DOMContentLoaded',
                attrs.loadBarInjectorToken
              );
            }
          }
        });
      } else {
        _0x416471 = _0x36e92a;
      }
    });
  });
  var imageCount = 0;
  var lazyImages = 20;
}

/** Obfuscator string table (mostly unused after deobfuscation leftovers). */
function getStringTable() {
  var table = [
    'WNaNA',
    'IFRAME',
    'pPKEP',
    'Loaded',
    'xkwjN',
    'src',
    'error',
    'QiCSR',
    '14oXjnsD',
    'nZlmL',
    '1339yownEG',
    'includes',
    'info',
    'xiXrX',
    'adcUZ',
    'WdHGw',
    '20707hwrAqb',
    'RFUCT',
    'forEach',
    'aDuKF',
    'KNiAk',
    'WGLLi',
    'toString',
    'attachEven',
    'CrOS',
    'wuVMB',
    'rix',
    'exception',
    'GqruC',
    'QcAiz',
    'rn this")(',
    'iLEQF',
    'cgecb',
    'LnIis',
    'hVxaE',
    'mmHac',
    'yynFJ',
    '___plt',
    'ztNQs',
    'href',
    'nodeType',
    '___mnag',
    'loadBarInj',
    'YyRvu',
    'SLXfb',
    'Injector',
    'OLYmK',
    'SCCRIPT',
    'return (fu',
    'PIvNT',
    'yboGR',
    '52074VdGwnS',
    'dSgHF',
    'split',
    'SqwgX',
    'x86_64',
    'HQyIF',
    'emfDv',
    'sUYVI',
    'FTPpQ',
    'ncLazyLoad',
    '54qhigPF',
    'vCcRQ',
    'VzIBT',
    'ZedTZ',
    'YzHRp',
    'LIINK',
    'VHUtQ',
    'VpnWg',
    'ngFQR',
    'AilLW',
    'pnGQl',
    'UtLRl',
    'SlAyo',
    '22628WiLnih',
    "',function",
    'MZfCx',
    'mBosC',
    'SdPeI',
    'vIvmW',
    'bkPWw',
    'wvqxI',
    'XMrYv',
    'ibute',
    'gpCNL',
    'CeJdx',
    'outerWidth',
    'constructo',
    'data-src',
    'KeoDc',
    'replaceAll',
    'WrIWS',
    '{}.constru',
    'table',
    'tagName',
    'length',
    ', asyncLoa',
    'NKhYM',
    'Mrbkn',
    'uKTTj',
    'OZiGl',
    'outerHeigh',
    '5072137bkXMmV',
    'ShyZg',
    'NgwWd',
    'mvnVv',
    '___mnag1',
    'LVdkS',
    'form',
    'plat',
    'pulVR',
    'tfEYr',
    'ooRrl',
    'LINK',
    '__proto__',
    'FevdZ',
    'AvrSJ',
    'MZgZS',
    'HaRCj',
    'sSKwj',
    'KqAKk',
    'dVuxX',
    'data-href',
    'kOkNV',
    'DVTwB',
    'oZiBs',
    'iSeKD',
    'type',
    'qlbio',
    'innerHTML',
    'QazYq',
    'DjDQC',
    'NqdDV',
    'ddEventLis',
    'text/lazyl',
    'indexOf',
    'KyQQI',
    'if(window.',
    'wHEVc',
    '175NOnfJr',
    'apply',
    'QsgRE',
    'QJAIz',
    'szfOV',
    'nction() ',
    ', function',
    'EsbNl',
    'YYnfY',
    'QLoEb',
    'lazy',
    'rgoDH',
    'fbqpy',
    'gISjR',
    'uXbjD',
    'phRND',
    'TRQMp',
    'uTdnR',
    'KFVRy',
    '24SGveWv',
    'vVKxy',
    'hMtiA',
    'Nixcf',
    'rifjW',
    'PSaCE',
    'vrJVM',
    '10gzLHZl',
    'IFFRAME',
    'dTmLz',
    'prototype',
    'Attph',
    'XtsQJ',
    'oUfDU',
    'GXaWY',
    'aYpZd',
    'warn',
    'NiwyK',
    'weImC',
    'xfYCU',
    'KSLrl',
    'BLXNQ',
    'BkpaH',
    'Epniy',
    'qceKb',
    'FIYxG',
    'removeAttr',
    'CygkU',
    'QCxQk',
    'DfNju',
    'XcfFy',
    'bckZY',
    'PreviewBar',
    'vwLzR',
    'TFprn',
    'UeEIt',
    'zYmsc',
    'gAwuC',
    'NxSBj',
    'grsUH',
    'QjoWA',
    '300516fDvxeb',
    'gbQue',
    'childList',
    'IMMG',
    'etFnh',
    "tener('asy",
    'yncLoad();',
    'adminBarIn',
    'jector',
    'iWJnh',
    'OatMb',
    'subtree',
    'IMG',
    'SCRIPT',
    'ow.attachE',
    'gmEsr',
    'search',
    'loading',
    'DJbVn',
    'setAttribu',
    '(((.+)+)+)',
    'vent)',
    'ector',
    'BZgAT',
    '7574688NMXQsB',
    '(event){as',
    'WTLOF',
    '});if(wind',
    'WtmrL',
    'wJkCa',
    'FEOsP',
    'LBmJq',
    'bind',
    'documentEl',
    'nTZbe',
    'QaTqg',
    'MudwU',
    'HPbFl',
    'document.a',
    'oad',
    '1577574QymoHJ',
    'ement',
    'UZRrH',
    'console',
    'qAEzd',
    'gJAMg',
    'gent',
    'replace',
    'UDOHZ',
  ];
  getStringTable = function () {
    return table;
  };
  return getStringTable();
}

var observerConfig = {childList: true};
observerConfig.subtree = true;
mutationObserver.observe(document.documentElement, observerConfig);
